<template>
  <div>
    <v-btn icon @click="abrirDialog()" small>
      <v-icon small>mdi-chart-areaspline</v-icon>
    </v-btn>
    <v-layout>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
        persistent
      >
        <v-card tile>
          <v-toolbar flat dark color="#042333">
            <v-btn icon dark @click="fechar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Raio X do Item</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="mt-10">
              Produto: {{ nomeProduto }}
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text id="dialog-text">
            <div style="display: flex">
              <div :class="expandido ? 'ocultar' : 'exibir'">
                <caracteristicas-estatisticas
                  id="carac-estat"
                  class="mt-1 ml-1"
                  :atualizar="dialog"
                  :qtdeMeses="periodo"
                ></caracteristicas-estatisticas>
              </div>
              <div :class="expandido ? 'inteira' : 'dividido'">
                <div id="titulo-chart">
                  <div id="menu" class="mr-2">
                    <v-btn icon color="#444" @click="expandirEncolher">
                      <v-icon>mdi-menu</v-icon>
                    </v-btn>
                  </div>
                  <h4 style="color: #444">
                    Período Análisado:
                    <span v-if="periodoSelecionado.min">{{
                        `${formatoData(periodoSelecionado.min)}
                      até ${formatoData(periodoSelecionado.max)}`
                      }}</span>
                  </h4>
                  <v-spacer></v-spacer>
                  <div id="periodos">
                    <span
                      :class="{ ativo: ativo === 1 }"
                      @click="
                        periodo = 1;
                        ativo = 1;
                      "
                    >
                      1 mês
                    </span>
                    <span
                      :class="{ ativo: ativo === 2 }"
                      @click="
                        periodo = 2;
                        ativo = 2;
                      "
                    >
                      2 meses
                    </span>
                    <span
                      :class="{ ativo: ativo === 3 }"
                      @click="
                        periodo = 3;
                        ativo = 3;
                      "
                    >
                      3 meses
                    </span>
                    <span
                      :class="{ ativo: ativo === 6 }"
                      @click="
                        periodo = 6;
                        ativo = 6;
                      "
                    >
                      6 meses
                    </span>
                    <span
                      :class="{ ativo: ativo === 9 }"
                      @click="
                        periodo = 9;
                        ativo = 9;
                      "
                    >
                      9 meses
                    </span>
                    <span
                      :class="{ ativo: ativo === 12 }"
                      @click="
                        periodo = 12;
                        ativo = 12;
                      "
                    >
                      1 ano
                    </span>
                    <span
                      :class="{ ativo: ativo === 13 }"
                      @click="
                        periodo = 13;
                        ativo = 13;
                      "
                    >
                      Consolidado
                    </span>
                  </div>
                </div>
                <div>
                  <chart-saldos
                    v-if="dialog"
                    id="chart-saldo"
                    :atualizar="dialog"
                    :periodo="periodo"
                    @periodo="periodoSelecionado = $event"
                    @zerarPeriodo="periodo = 0"
                  ></chart-saldos>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import caracteristicasEstatisticas from "./CaracteristicasEstatisticas";
// import chartTorta from "../../layout/ChartTorta";
import chartSaldos from "./ChartSaldos";

export default {
  components: {
    caracteristicasEstatisticas,
    // chartTorta,
    chartSaldos,
  },

  props: {
    produto: {
      type: Object
    }
  },

  data: () => ({
    dialog: false,
    expandido: true,
    habilitarReinicio: false,
    periodoSelecionado: {},
    periodo: 13,
    ativo: 13,
  }),

  created() {
    if (this.$route.path == '/indicador_status_produto') {
      this.$store.dispatch("detalhe_produto/setProduto", { id_grupo: '', idproduto: '', descricao_produto: '' });
      this.$store.dispatch("fornecedor/setFornecedor", { id: '', razao_social: '' });
    }
  },

  computed: {
    ...mapGetters({
      detalhesProduto: "detalhe_produto/getProduto",
    }),

    nomeProduto: function () {
      return this.detalhesProduto.idproduto
        .concat(" - ")
        .concat(this.detalhesProduto.descricao_produto);
    },
  },

  methods: {
    abrirDialog() {
      if (this.$route.path == '/indicador_status_produto') {
        this.$store.dispatch("detalhe_produto/setProduto", this.produto);
        this.$store.dispatch("fornecedor/setFornecedor", {
          id: this.produto.idfornecedor,
          razao_social: this.produto.razao_social
        });
      }

      this.dialog = true;
    },

    formatoData: function (date) {
      if (typeof date === "number") {
        const data = new Date(date);
        const dia = data.getDate() < 10 ? "0" + data.getDate() : data.getDate();
        const mes =
          data.getMonth() < 9
            ? "0" + (data.getMonth() + 1)
            : data.getMonth() + 1;
        const ano = data.getFullYear();

        return `${dia}/${mes}/${ano}`;
      } else {
        const dtArray = date.split("-");
        return `${dtArray[2]}/${dtArray[1]}/${dtArray[0]}`;
      }
    },
    fechar: function () {
      this.dialog = false;
      this.expandido = true;
      this.habilitarReinicio = false;
      this.periodo = 13;
      this.ativo = 13;
    },

    getData: function (valor) {
      const data = new Date(valor);

      let mes = data.getMonth() + 1;
      mes = mes < 10 ? "0".concat(mes) : mes;

      const ano = data.getFullYear();

      return `${mes}/${ano}`;
    },

    expandirEncolher: function () {
      this.expandido = !this.expandido;
    },
  },
};
</script>

<style scoped>
#carac-estat {
  height: calc(100vh - 77px) !important;
  overflow: auto;
}
#chart-torta {
  height: 200px;
}
#dialog-text {
  padding: 0;
  height: calc(100vh - 65px) !important;
  overflow-y: hidden;
}
.dividido {
  width: 75%;
  transition: 0.3s;
}
.inteira {
  width: 100%;
  transition: 0.3s;
}
#chart-saldo {
  height: calc(100vh - 100px) !important;
}
#titulo-chart {
  display: flex;
  padding-top: 10px;
  padding-left: 22px;
  padding-right: 10px;
}
.exibir {
  width: 25%;
  transition: 0.3s;
}
.ocultar {
  margin-left: -25%;
  width: 25%;
  transition: 0.3s;
}
#menu {
  margin-top: -8px;
  margin-bottom: -20px;
  margin-left: -15px;
}
#periodos {
  margin-right: 10px;
  padding: 0;
}
#periodos span {
  text-transform: uppercase;
  font-size: 11px;
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;
  margin-left: 5px;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
#periodos span:hover {
  background: #042333;
  color: #fff;
}
span {
  color: #333;
}
.ativo {
  background: #042333;
  color: #fff;
}
</style>
